import { createTheme } from '@material-ui/core/styles'
import { DEFAULT_THEME_CONFIG } from '@scoir/mui-theme'

const AuthDefaultTheme = {
  ...DEFAULT_THEME_CONFIG,
}

const theme = createTheme(AuthDefaultTheme)

export default theme
